import React from 'react';
import { useAuth } from '../../components/auth/AuthContext';
import { useOFEFetch } from './useOFE';

const TYPE_ICONS = { warehouse: '🏢', yard: '🏗️', site: '📍', '3pl': '🚛' };

export default function OFEStorageLocations() {
  const { user } = useAuth();
  const { data: locations, loading } = useOFEFetch('/ofe/logistics/storage', user);

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-xl font-bold text-white">Storage Locations</h1>

      {loading && <div className="text-gray-400">Loading...</div>}

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {(locations || []).map(loc => (
          <div key={loc.id} className="bg-gray-800 border border-gray-700 rounded-lg p-4 space-y-2">
            <div className="flex items-center gap-2">
              <span className="text-2xl">{TYPE_ICONS[loc.location_type] || '📦'}</span>
              <div>
                <div className="text-white font-semibold">{loc.location_name}</div>
                <div className="text-gray-400 font-mono text-xs">{loc.location_code}</div>
              </div>
            </div>
            <div className="text-xs text-gray-400 capitalize">{loc.location_type}</div>
            {loc.provider_3pl && <div className="text-xs text-gray-300">3PL: {loc.provider_3pl}</div>}
            {loc.address && <div className="text-xs text-gray-400">{loc.address}</div>}
            {loc.current_utilization_pct !== null && (
              <div>
                <div className="flex justify-between text-xs text-gray-400 mb-1">
                  <span>Utilization</span><span>{loc.current_utilization_pct?.toFixed(0)}%</span>
                </div>
                <div className="bg-gray-700 rounded-full h-1.5">
                  <div className={`h-1.5 rounded-full ${loc.current_utilization_pct > 80 ? 'bg-red-500' : loc.current_utilization_pct > 60 ? 'bg-yellow-500' : 'bg-green-500'}`}
                    style={{ width: `${Math.min(loc.current_utilization_pct, 100)}%` }} />
                </div>
              </div>
            )}
            {loc.contact_name && <div className="text-xs text-gray-400">Contact: {loc.contact_name} {loc.contact_phone}</div>}
          </div>
        ))}
        {!locations?.length && !loading && (
          <div className="col-span-3 text-center py-12 text-gray-500">No storage locations</div>
        )}
      </div>
    </div>
  );
}
